import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import request from "@/lib/api/handler";

import { toast } from "sonner";

export const useStripeBillingPortalRedirect = () => {
  const { getAccessTokenSilently } = useAuth0();

  const {
    mutate: redirectToStripeBillingPortal,
    isPending: redirectToStripeBillingPortalPending,
    error: redirectToStripeBillingPortalError,
  } = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();
      return request<{ url: string }>({
        method: "POST",
        path: "/api/payment/billing-portal-link",
        token,
      });
    },
    onMutate: () => {
      toast.info("Redirecting to Stripe...");
    },
    onSuccess: (data) => {
      window.open(data.url, "_blank");
    },
    onError: () => {
      toast.error("Redirect error");
    },
  });

  return {
    redirectToStripeBillingPortal,
    redirectToStripeBillingPortalPending,
    redirectToStripeBillingPortalError,
  };
};
